import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import CohortCard from "./CohortCard";
import { useDispatch } from "react-redux";
import {
  setCohortApplied,
  setIsEditCohort,
  setResetSearchTextForAdditionalInstitutions,
  setResetSearchTextForCities,
  setSelectedCohort,
} from "../../../../rtk-query/features/cohort/cohortSlice";
import exportimages from "../../../../assets/images/exportImages";
import { fnCheckDollarUnits } from "../../widget/widgetsCommonFunction";

const getAssetValue = (val) => {
  const parsed = Number(val);
  return typeof parsed === "number" && !Number.isNaN(parsed) ? parsed : 0;
};

const NO_DATA_DELAY_MS = 1000;

const SuggestedCohort = ({ cohortList }) => {
  const dispatch = useDispatch();
  const [validCohortList, setValidCohortList] = useState([]);
  const [showNoData, setShowNoData] = useState(false);

  useEffect(() => {
    setValidCohortList(cohortList?.filter((i) => i?.cohortType === 1));
  }, [cohortList]);

  useEffect(() => {
    if (validCohortList?.length === 0) {
      setTimeout(() => setShowNoData(true), NO_DATA_DELAY_MS);
    } else {
      setShowNoData(false);
    }
  }, [validCohortList]);

  const handleCohortSelect = (cohort) => {
    dispatch(setSelectedCohort(cohort));
    dispatch(setCohortApplied(null));
    dispatch(setIsEditCohort(false));
    dispatch(setResetSearchTextForAdditionalInstitutions(true));
    dispatch(setResetSearchTextForCities(true));
  };

  return (
    <div className="list-cohort flex-start">
      {validCohortList?.length > 0
        ? validCohortList?.map((cohort) => {
            const cohortResult = cohort?.cohortResult;
            const filterJson = cohort?.filterJson;
            const minInput = getAssetValue(filterJson?.assets?.min);
            const maxInput = getAssetValue(filterJson?.assets?.max);
            const { score: minAssetSize, unit: minAssetSizeUnit } =
              fnCheckDollarUnits(minInput);
            const { score: maxAssetSize, unit: maxAssetSizeUnit } =
              fnCheckDollarUnits(maxInput);

            return (
              // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
              <div
                key={cohort?.uid}
                onClick={() => handleCohortSelect(cohort)}
                className="w-100"
              >
                <CohortCard
                  uid={cohort?.uid}
                  title={cohort?.name}
                  subtitle={cohort?.description}
                  range={`$${minAssetSize?.toFixed(2)}${minAssetSizeUnit} – $${maxAssetSize?.toFixed(2)}${maxAssetSizeUnit}`}
                  institutions={cohortResult?.institution_count}
                  avg={cohortResult?.cohort_avg}
                  percentile={cohortResult?.percentile}
                />
              </div>
            );
          })
        : showNoData && (
            <div className="message-container">
              <div className="message">
                <div className="no_cohort">
                  <img alt="icon" src={exportimages.no_cohort} />
                </div>
                <div className="message">No Suggested Cohorts Yet</div>
                <div className="desc">System has not suggested any cohort.</div>
              </div>
            </div>
          )}
    </div>
  );
};

SuggestedCohort.propTypes = {
  cohortList: PropTypes.array,
};

export default SuggestedCohort;
